// extracted by css-extract-rspack-plugin
export default {"wrapper":"_b545797c","header":"_f169e5d0","viewMoreButton":"_bef3a6e1"};